/**
 * Page d'erreur 403 (accès refusé).
 */

import { useTranslation } from 'react-i18next'

export const Error403 = () => {
  const { t } = useTranslation()

  return (
    <div className="w-full flex flex-col items-center h-full pt-60px">
      <div className="text-[120px] font-bold leading-none text-red-1300 dark:text-red-1350">
        403
      </div>
      <div className="mt-[20px] text-red-1300 text-2xl dark:text-red-1350">
        {t('error403')}
      </div>
    </div>
  )
}
